const downloadXLSXBlob = (response, archiveName) => {
    /* Adicionar *({ responseType: 'blob' })* em Header da Requisição */
    const url  = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href  = url;
    link.setAttribute("download", archiveName);
    document.body.appendChild(link);
    link.click();
}

export default downloadXLSXBlob;